import { render } from "./liqudityWarning.vue?vue&type=template&id=c0e53e74&scoped=true&lang=pug"
import script from "./liqudityWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./liqudityWarning.vue?vue&type=script&setup=true&lang=js"

import "./liqudityWarning.vue?vue&type=style&index=0&id=c0e53e74&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e53e74"]])

export default __exports__